import controller from './enter-virtual-data-controller';
import template from './enter-virtual-data.html'

const EnterVirtualDataComponent = {
    bindings: {
        clientList: '<',
        facilityFields: '<',
        facilitySettings: '<',
        formMetadata: '<',
        changeReasonList: '<',
        isFormVisible: '<',
        relatedModels: '<',
        savedFormData: '<',
        statToLabelDict: '<',
        lastUpdatedByEmail: '<'
    },
    controller,
    template,
};

export default EnterVirtualDataComponent;



// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data-component.js